import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { AiFillCloseCircle } from "react-icons/ai";
import { SessionKeyEnum } from "../../../Enumeration/SessionKeyEnum";
import { getAPI } from "../../../Hooks/UseResource";
import VideoKycResource from "../../Resources/VideoKycResource/VideoKycResource";

function CsplVideoComponent(props) {
  let [showpopup, setShowpopup] = useState(false);

  const [videoUrl, setVideoUrl] = useState("");
  const [
    videoKycCreateProfile,
    videoKycProfileStatus,
    updateWidgetStatus,
    validateDateForVideoKyc,
    removePersonalInfoData,
    getVideoKYCData,
  ] = VideoKycResource();
  function popupClose() {
    setShowpopup(!showpopup);
  }
  useEffect(() => {
    setShowpopup(false);
  }, []);

  useEffect(() => {
    const loadVideo = async () => {
      let videoKYCURL = "";
      if (props.localServerPath) {
        videoKYCURL =
          getAPI() +
          "get-video-kyc" +
          "/" +
          sessionStorage.getItem(SessionKeyEnum.Id) +
          "/" +
          sessionStorage.getItem(SessionKeyEnum.KycApplicationId) +
          "/" +
          props.holderType +
          "/" +
          props.Title;

        const res = await fetch(videoKYCURL, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem(SessionKeyEnum.AppKey)}`,
          },
        });

        const blob = await res.blob();
        const url = URL.createObjectURL(blob);

        setVideoUrl(url);
      } else {
        setVideoUrl(props.srcURl);
      }
    };

    loadVideo();
  }, []);
  const { t } = useTranslation("common");
  return (
    <>
      <React.Fragment>
        <div id="player">
          <div className="videoKYC p-2">
            <div className="card_header">
              <h5 className="mb-0 ml-2 videoKYC_title"> {t(props.Title)} </h5>
              {/* <img src={props.logo} className='mb-0 videoKYC_logo'/> */}
            </div>
            {
              <img
                src={"./Assets/Images/View_Video_Icon.png"}
                className="ml-3 video-element"
              />
            }
            <div id="controls">
              <div onClick={popupClose} className="play_icon" />
              <Modal
                className="modal-background"
                show={showpopup}
                onHide={popupClose}
                backdrop="static"
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
              >
                <Modal.Body className="modalbody">
                  <AiFillCloseCircle
                    onClick={popupClose}
                    className="close-icon-color"
                    size={20}
                  />
                  <video
                    id="popupVideo"
                    src={videoUrl}
                    className="video"
                    controls
                  ></video>
                </Modal.Body>
              </Modal>
            </div>
            <div></div>
          </div>
          <div className="mt-4 mb-2 video_helper_text">
            {t(props.helperText)}
          </div>
        </div>
      </React.Fragment>
    </>
  );
}

export default CsplVideoComponent;
